import React from "react";

// Dashboard
import DashboardOverview from "../dashboard/overview";
import HelpdeskService from "../dashboard/HelpdeskService";
import StorageManagement from "../dashboard/StorageManagement";
import ProductManagement from "../dashboard/ProductManagement";


// Apps
import Chat from "../apps/Chat";

// Pages
import Faq from "../pages/Faq";
import Profile from "../pages/Profile";
import Events from "../pages/Events";
import Settings from "../pages/Settings";

// UI Elements
import ScheduleAppointment from "../dashboard/ScheduleApointment";
// import AppointmentHistory from "../dashboard/AppointmentHIstory";
import MyAppointments from "../dashboard/MyAppointments";
import PrevisitForm from "../dashboard/PrevisitForm";
import CurrentMedications from "../pages/currentMedications";
import MedicationsHistory from "../pages/medicationsHistory";
import Invoice from "../pages/invoice";
import AllPatients from "../dashboard/doctorsDahboard/patients";
import DrugMart from "../dashboard/drugMart";
import Schedule from "../dashboard/ScheduleApointment";
import MyDocuments from '../pages/MyDocument'
import ExcuseDuty from '../pages/ExcuseDuty'
import Allergies from "../pages/Allergies";
import ProblemList from "../pages/ProblemList";
import ClinicalTask from "../pages/ClinicalTask";
import LabourHistory from "../pages/LabourHistory";
import IvfHistory from "../pages/IvfHistory";
import AntenatalHistory from "../dashboard/AntenatalHistory";
import AdmissionHistory from "../dashboard/admissionHistory";
// import VissitSummary from "../dashboard/visitSummary";
import LabRequestHistory from "../pages/LabRequestHistory";
import LabMart from "../dashboard/LabMart";
import PurchasedDrugs from "../pages/PurchasedDrugs";
import MedicationTab from "../pages/MedicationTabs";
import PaymentStatus from "../pages/PaymentStatus";
import MedicalChatbot from "../pages/Support";

const protectedRoutes = [
  { path: "/", element: <DashboardOverview /> },
  { path: "lab/request", element: <LabMart /> },
  { path: "dashboard/overview", element: <DashboardOverview /> },
  {path: "dashboard/myappointment", element: <MyAppointments />},
  { path: "history/antenatal", element: <AntenatalHistory /> },
  { path: "history/admission", element: <AdmissionHistory /> },
  // { path: "history-vissit-summary", element: <VissitSummary /> },
  // { path:"dahboard/payment/status", element: <PaymentStatus/>},
  { path: "appointment/schedule", element: <Schedule /> },
  { path: "/examinations", element: <LabRequestHistory /> },

  { path: "/dashboard/support", element: <MedicalChatbot/> },
  
  // {path: "", element: <}
  { path: "dashboard/schedule-appointment", element: <ScheduleAppointment /> },
  // { path: "dashboard/appointment-history", element: <AppointmentHistory /> },
  { path: "dashboard/previsit-form", element: <PrevisitForm /> },
  { path: "dashboard/helpdesk", element: <HelpdeskService /> },
  { path: "dashboard/storage", element: <StorageManagement /> },
  { path: "dashboard/product", element: <ProductManagement /> },
  { path: "apps/chat", element: <Chat /> },
  { path: "pages/profile", element: <Profile /> },
  { path: "page/documents", element: <MyDocuments /> },
  { path: "page/excuse-duty", element: <ExcuseDuty /> },
  
  // new pages
  { path: "page/allergies", element: <Allergies /> },
  { path: "page/problem-list", element: <ProblemList /> },
  { path: "page/clinical-task", element: <ClinicalTask /> },
  { path: "page/labour-history", element: <LabourHistory /> },
  { path: "page/ivf-history", element: <IvfHistory /> },
  // {path: "page/purchased-drugs", element: <PurchasedDrugs />},
  

  // medications
  { path: "medications/current", element: <CurrentMedications /> },
  { path: "/medications", element: <MedicationTab/>},
  // { path: "medications/history", element: <MedicationsHistory /> },
  // { path: "medication/drug-mart", element: <DrugMart /> },

  // payments and invoices
  { path: "bills", element: <Invoice /> },



  // Doctors Dashboard
  { path: "Doctors/AllPatients", element: <AllPatients/> },


  // { path: "pages/activity", element: <Activity /> },
  { path: "pages/events", element: <Events /> },
  { path: "pages/settings", element: <Settings /> },
  
]

export default protectedRoutes;